import { render } from "./UserChangePassword.vue?vue&type=template&id=973099f8"
import script from "./UserChangePassword.vue?vue&type=script&lang=js"
export * from "./UserChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__